export class HttpRequest {
  public constructor() {
    this.Url = '';
    this.InProgress = false;
    this.Completed = false;
    this.EnableCaching = false;
    this.SlidingCache = false;
    this.CacheExpires = new Date();
    this.SlidingCacheSeconds = 0;
    this.PrimaryRequest = false;
    this.ResponsePromise = null;
    this.ResponseData = null;
  }
  public Url: string;
  public InProgress: boolean;
  public Completed: boolean;
  public EnableCaching: boolean;
  public SlidingCache: boolean;
  public CacheExpires: Date;
  public SlidingCacheSeconds: number;
  public PrimaryRequest: boolean;
  public ResponsePromise: Promise<any>;
  public ResponseData: any;
}
